import { AppFileTypes, mimeTypeToAppType } from 'utils/file/MIMETypeUtils';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const useItemThumbnailSrc = (item: useItemHandleFragment$data) => {
  switch (item.__typename) {
    case 'FolderItem':
    case 'AnnouncementAttachment':
    case 'MemberDetailsAttachment':
      switch (item.content?.__typename) {
        case 'File':
          if (mimeTypeToAppType(item.content.mimeType) === AppFileTypes.IMAGE) {
            return item.content.url || null;
          }
      }
  }
  return null;
};
